// eslint-disable-next-line  @typescript-eslint/no-explicit-any
type TCallback<D = any> = (data: D) => void;

export class EventEmitter {
  eventListenersMap: Record<string, Array<TCallback>> = {};

  public emit = <D>(event: string, data: D): void => {
    const callbacks = this.eventListenersMap[event];

    if (callbacks) {
      callbacks.forEach((callback) => callback(data));
    }
  };

  public on = <D>(event: string, callback: TCallback<D>): void => {
    if (this.eventListenersMap[event]) {
      this.eventListenersMap[event].push(callback);
    }
    this.eventListenersMap[event] = [callback];
  };

  public off = <D>(event: string, callback: TCallback<D>): void => {
    const currentEventCallbacks = this.eventListenersMap[event];

    if (currentEventCallbacks) {
      this.eventListenersMap[event] = currentEventCallbacks.filter(
        (fn) => fn !== callback
      );
    }
  };
}

export const emitter = new EventEmitter();
